export default __webpack_public_path__ + "static/media/info_green.85cc662d.svg";